var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}));
}

ArrowDown.defaultProps = {"viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
